import { render, staticRenderFns } from "./OnlineTeacher.vue?vue&type=template&id=65b088fe&scoped=true&"
import script from "./OnlineTeacher.vue?vue&type=script&lang=js&"
export * from "./OnlineTeacher.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./OnlineTeacher.vue?vue&type=style&index=1&id=65b088fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b088fe",
  null
  
)

export default component.exports